import AnnotationSettings from 'mirador/dist/es/src/containers/AnnotationSettings'

const exportedObject = {
  name: 'AnnotationsToggle',
  target: 'WindowTopBarPluginArea',
  mode: 'add',
  component: AnnotationSettings,
}

export default exportedObject
